/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feVoicemail', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherVoicemailIconData */

/** @type {FeatherVoicemailIconData} */
const feVoicemail = {
  prefix: 'fe',
  iconName: 'voicemail',
  icon: [
    24,
    24,
    '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-voicemail"><path d="M10 11.5 A4.5 4.5 0 0 1 5.5 16 A4.5 4.5 0 0 1 1 11.5 A4.5 4.5 0 0 1 10 11.5 z"/><path d="M23 11.5 A4.5 4.5 0 0 1 18.5 16 A4.5 4.5 0 0 1 14 11.5 A4.5 4.5 0 0 1 23 11.5 z"/><path d="M5.5 16 L18.5 16"/></svg>',
    'M10 11.5 A4.5 4.5 0 0 1 5.5 16 A4.5 4.5 0 0 1 1 11.5 A4.5 4.5 0 0 1 10 11.5 z M23 11.5 A4.5 4.5 0 0 1 18.5 16 A4.5 4.5 0 0 1 14 11.5 A4.5 4.5 0 0 1 23 11.5 z M5.5 16 L18.5 16',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feVoicemail
